import qs from 'qs';
import BaseHttp from '@/plugins/baseHttp';
import BaseFormat from '@/plugins/baseFormat';

const get = ({ page, _id, name, published, publish_status,
  logisticOperator_id, sort, sortBy, dispatchType, },) => {
  const offset = ((page || 1) - 1) * 15;
  const sortStrings = BaseFormat.sortString(sort, sortBy,);

  if (_id) { return BaseHttp.get(`/stores/${_id}`,); }

  const queryObj = {
    name: name ?? undefined,
    published: published,
    publish_status,
    dispatch_type: dispatchType,
    logisticOperator_id: logisticOperator_id || undefined,
    fields: 'name,address.city,address.state,published,publish_status,dispatch_type,last_order',
    sort: !Array.isArray(sortStrings,) ? sortStrings :
      sortStrings.join(',',) ||
      undefined,
    limit: '15',
    offset: offset || undefined,
  };
  const query = `/stores${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(query,);

};

const getAll = (filters,) => {

  const {
    page,
    _id,
    name,
    published,
    publish_status,
    logisticOperator_id,
    sort,
    sortBy,
    dispatchType,
  } = filters;

  const offset = ((page || 1) - 1) * 15;
  const sortStrings = BaseFormat.sortString(sort, sortBy,);

  if (_id) { return BaseHttp.get(`/stores/${_id}`,); }

  const queryObj = {
    name: name ?? undefined,
    published: published,
    publish_status,
    dispatch_type: dispatchType,
    logisticOperator_id: logisticOperator_id || undefined,
    fields: 'name,address.city,address.state,published,publish_status,dispatch_type,last_order',
    sort: !Array.isArray(sortStrings,) ? sortStrings :
      sortStrings.join(',',) ||
      undefined,
    limit: '15',
    offset: offset || undefined,
  };
  const query = `/stores${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(query,);

};

const getUserStores = (filters,) => {

  const valuePaymentType = filters.payment_type;

  if(valuePaymentType === 'Apenas no App') {
    filters.payment_type = 1;
  } else if(valuePaymentType === 'Entrega e App') {
    filters.payment_type = 2;
  } else if(valuePaymentType === 'Nenhum') {
    filters.payment_type = 3;
  }

  const {
    page,
    name,
    city,
    publish_status,
    financial_status,
    document_type_current,
    payment_type,
    cnpj,
    cpf,
    company_id,
    company_uuid,
    limit,
    sort,
    sortBy,
  } = filters;

  const offset = page;
  const sortStrings = BaseFormat.sortString(sort, sortBy,);

  const queryObj = {
    name,
    city,
    publish_status,
    financial_status,
    document_type_current,
    payment_type,
    cnpj,
    cpf,
    company_id,
    company_uuid,
    limit,
    sort: !Array.isArray(sortStrings,) ? sortStrings :
      sortStrings.join(',',) ||
      undefined,
    page: offset || undefined,
  };

  const query = `/stores/user-stores${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(query,);

};

const getAssignableStores = () => {
  return BaseHttp.get(
    '/stores?limit=-1&dispatch_type=DEDICATED&fields=_id,name,bringg_team_id',
  );
};

const putStoreFences = ({ _id, body, },) => {
  return BaseHttp.put(`/stores/${_id}/fences`, body,);
};

const removeStoreFence = ({ _id, companyFenceId, },) => {
  return BaseHttp.delete(`/stores/${_id}/fences/${companyFenceId}`,);
};

const getStoreFences = ({ _id, limit, page, district_name, },) => {
  const offset = ((page || 1) - 1) * 15;

  const queryObj = {
    district_name: district_name ? `/${district_name}/i` : undefined,
    limit: limit || '15',
    offset: offset || undefined,
  };
  const query = `/stores/${_id}/fences${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(
    query,
  );
};

const getStoreAvailableFences = ({ _id, },) => {
  return BaseHttp.get(`/stores/${_id}/availableFences`,);
};

const patchAssignedDrivers = ({ _id, added_drivers, removed_drivers, },) => {

  const body = {
    added_drivers,
    removed_drivers,
  };

  return BaseHttp.patch(`/stores/${_id}/drivers`, body,);

};

const post = (store,) => {
  return BaseHttp.post('/stores', store,);
};

const patch = (storeId, body,) => {
  return BaseHttp.patch(`/stores/${storeId}`, body,);
};

const removeAttachment = (storeId, attachmentId,) => {
  return BaseHttp.delete(`/stores/${storeId}/attachments/${attachmentId}`,);
};

const postAttachment = (storeId, body,) => {
  return BaseHttp.post(`/stores/${storeId}/attachments`, body,);
};

const getStoreReports = ({ begin_date, end_date, },) => {
  return BaseHttp.get(`/stores/reports/summary?begin_date>=${begin_date}&end_date<=${end_date}`,);
};

const exportStoreReports = ({ storeIds, begin_date, end_date, },) => {
  return BaseHttp.post('/stores/reports/export', {
    store_ids: storeIds,
    begin_date: {
      $gte: begin_date,
    },
    end_date: {
      $lte: end_date,
    },
  },);
};

const getStoresIndicators = ({ begin_date, end_date, },) => {
  return BaseHttp.get(`/stores/summary?begin_date>=${begin_date}&end_date<=${end_date}`,);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

export default {
  get,
  getAll,
  getUserStores,
  getStoreReports,
  getStoreFences,
  getStoreAvailableFences,
  post,
  patch,
  patchAssignedDrivers,
  putStoreFences,
  exportStoreReports,
  postAttachment,
  removeAttachment,
  removeStoreFence,
  getStoresIndicators,
  getAssignableStores,
  handleError,
};
